<template>
    <div class="col-lg-8 col-md-12 col-sm-12">
        <div class="card">
            <div class="body">
                <div v-for="group in workflowStore.groups" :key="group.groupCode">
                    <h4 v-if="group.groupCode == workflowStore.groupCode">
                        {{ group.groupName }}
                    </h4>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <label class="c_checkbox" id="deleteAllCheckbox">
                        <input
                            type="checkbox"
                            :checked="workflowStore.workflows.length == checkeds.length"
                            @click="checked(workflowStore.workflows)"
                        />
                        <span class="checkmark"></span>
                    </label>
                    <span style="float: right">
                        <button
                            class="btn btn-warning"
                            id="dashCreateBtn"
                            style="margin-right: 5px"
                            @click="goCreateworkflow()"
                        >
                          생성
                        </button>
                        <button
                            class="btn btn-default"
                            id="deleteWorkflowBtn"
                            @click="deleteWorkflowAll()"
                        >
                          삭제
                        </button>
                    </span>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="table-responsive" style="min-height: 700px">
                        <table class="table table-filter m-b-0" id="workflowListTabl">
                            <tbody>
                            <tr
                                v-for="(workflow, index) in workflowList"
                                :key="index"
                            >
                                <td>
                                    <label class="c_checkbox">
                                        <input
                                            type="checkbox"
                                            :value="workflow.workflowCode"
                                            v-model="checkeds"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                                <!--                <td width="150px">-->
                                <!--                  <div class="row">-->
                                <!--                    <h5 class="sizes" style="margin-bottom: 0;">-->
                                <!--                      <span class="size" title="small" style="margin-right: 5px">-->
                                <!--                        <img class="workIcon w60 rounded" alt="Rounded Image" src="@/assets/noimage.png" />-->
                                <!--                      </span>-->
                                <!--                      &lt;!&ndash;                      <span class="size" title="medium">&ndash;&gt;-->
                                <!--                      &lt;!&ndash;                        <font-awesome-icon :icon="faArrowRight" style="font-size: 15px;" />&ndash;&gt;-->
                                <!--                      &lt;!&ndash;                      </span>&ndash;&gt;-->
                                <!--                      <span class="size" title="large">-->
                                <!--                            <img class="workIcon w60 rounded" alt="Rounded Image" src="@/assets/noimage.png" />-->
                                <!--                      </span>-->
                                <!--                    </h5>-->
                                <!--                  </div>-->
                                <!--                </td>-->
                                <td width="350px">{{ workflow.workflowName }}</td>
                                <td>
                                    <div class="btn-group">
                                        <button
                                            class="btn round"
                                            :class="[
                                                  { 'btn-default': workflow.runYn == 'N' },
                                                  { 'btn-primary': workflow.runYn == 'Y' },
                                                ]"
                                            @click="changeRun(workflow.workflowCode, 'Y')"
                                        >
                                            실행
                                        </button>
                                        <button
                                            class="btn round"
                                            :class="[
                                              { 'btn-default': workflow.runYn == 'Y' },
                                              { 'btn-primary': workflow.runYn == 'N' },
                                            ]"
                                            @click="changeRun(workflow.workflowCode, 'N')"
                                        >
                                            끔
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <button
                                        class="header-dropdown btn btn-default"
                                        v-click-outside="clickDropOutside"
                                        @click.stop="showDropList(workflow.workflowCode)"
                                    >
                                    <span class="dropdown" data-toggle="dropdown" role="button">설정
                                        <ul
                                            class="dropdown-menu dropdown-menu-right"
                                            :class="{
                                            show: workflow.workflowCode == workflowDropCode,
                                          }"
                                        >
                                            <li><a @click="goEditor(workflow.workflowCode)">수정</a></li>
                                            <li><a @click="goConnections(index)">연결</a></li>
                                            <li v-if="workflow.templateYn == 'N'"><a @click="addToTemplate(index)" >템플릿에 등록</a></li>
                                            <li  v-if="workflow.templateYn == 'Y'"><a @click="addToTemplate(index)" >템플릿에서 제거</a></li>
                            <!-- 일단 주석 (삭제x)
                            <li>
                              <a @click="showModal(index, 'rename', 'open')"
                                >Rename</a
                              >
                            </li>
                            <li>
                              <a @click="showModal(index, 'move', 'open')"
                                >Move to Folder</a
                              >
                            </li> -->
                            <!-- <li><a @click="getHistoryList(workflow.workflowName)">기록</a></li> -->
                            <!-- Copy 기능 주석 (11/16) -->
                            <!-- <li><a>Copy</a></li> -->
                                            <li><a @click="deleteWorkflow(workflow.workflowCode)">삭제</a></li>
                                        </ul>
                                    </span>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="workflowList.length == 0">
                                <td>
                                    <div class="tab-pane card" id="Videos">
                                        <div class="body text-center">
                                            <div class="not_found">
                                                <font-awesome-icon style="font-size: 50px;" :icon="faFrown" />
                                                <!--                        <i class="zmdi zmdi-mood-bad zmdi-hc-4x"></i>-->
                                                <br>
                                                <h4 class="m-b-0">검색 결과가 없습니다.</h4>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="lastTr" colspan="5"></tr>
                            </tbody>
                        </table>
                    </div>

                    <div style="text-align: center;">
                        <button type="button" class="btn btn-primary " v-if="this.skipNum > 0" @click="getPreviousPage">이전</button>
                        <span v-for="num in Math.ceil(this.totalCount/this.pageNum)" :key="num">
                            <button class="btn" v-if="num != skipNum + 1 && num < skipNum + 4 && num > skipNum - 4"  style="color: forestgreen" @click="skipToPage(num)">{{ num }}</button>
                            <button type="button" class="btn" v-if="num == skipNum + 1" style="color: #00dd3a" @click="skipToPage(num)">{{ num }}</button>
                        </span>
                        <!--{{Math.floor(this.totalCount/this.pageNum)}}-->
                        <button type="button" class="btn btn-primary " v-if="this.workflowList.length == 20 && this.pageNum * this.skipNum + 20 < this.totalCount" @click="getNextPage">다음</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faFrown } from "@fortawesome/free-regular-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default {
    name: "workflow",
    components: {
        FontAwesomeIcon
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            workflowDropCode: "",
            workflowCode: "",
            selecFolder: "",
            checkeds: [],
            groupsName: [],
            workflowList: [],

            pageNum : 20,
            skipNum : 0,
            totalCount : 0,

            planName : null,
            planType : null,
            flowCount : 0,
            flowTotal : 0,
            workCount : 0,
            workTotal : 0,
            leadCount : 0,
            leadTotal : 0,

            faFrown,
            faArrowRight
        };
    },
    watch:{

        getGroupCode(code){
            this.getWorkflowList()
            this.getGroupList()
            console.log(code)
        }

    },
    computed: {
        workflowStore() {
            return this.$store.state.workflowStore;
        },
        userStore() {
            return this.$store.state.userStore;
        },
        getGroupCode (){
            return this.$store.state.workflowStore.groupCode;
        }
    },

    methods: {
        skipToPage(num) {
            this.skipNum = num-1;

            this.getWorkflowList();

        },
        countingIndex(index) {

            return this.skipNum * this.pageNum + index + 1;

        },
        getPreviousPage() {
            this.skipNum = this.skipNum - 1;

            this.getWorkflowList();
        },
        getNextPage() {
            this.skipNum = this.skipNum + 1;

            this.getWorkflowList();

        },
        addToTemplate(index){
            var status = 'N';
            var korean = '제거';

            if(this.workflowList[index].templateYn == 'Y'){
                console.log('적용')
                status = 'N'
                korean = '비적용'
            } else if(this.workflowList[index].templateYn == 'N'){
                console.log('비적용')
                status = 'Y'
                korean = '적용'
            }


            if(confirm('템플릿에 ' + korean +'으로 변경하시겠습니까?')){
                console.log(index)

                var param = {
                    workflowCode : this.workflowList[index].workflowCode,
                    setAsTemplate :status
                }

                this.api.setTemplate(param).then((res)=>{
                    console.log(res);
                    if(this.utils.preApiHandle(res)) {
                        console.log("profile edit res : ", res)
                    }
                    this.getWorkflowList()
                });
            }
        },
        showDropList(code) {
            if (this.workflowDropCode != code) {
                this.workflowDropCode = code;
            } else {
                this.workflowDropCode = "";
            }
        },
        showModal(i, tag, status) {
            // param : 모달창에서 필요한 내용
            // tag : 모달 종류
            // status : open / close
            var code = this.workflowStore.workflows[i].workflowCode;
            var name = this.workflowStore.workflows[i].workflowName;
            var param = { title: "workflow", workflowCode: code, workflowName: name };

            this.$store.dispatch("showModal", {
                params: param,
                tag: tag,
                status: status
            });

            document.getElementsByClassName("overlay")[0].style.display = "block";
        },
        checked(workflows) {
            if (this.checkeds.length != workflows.length) {
                this.checkeds = [];
                for (var i = 0; i < workflows.length; i++) {
                    this.checkeds.push(workflows[i].workflowCode);
                }
            } else {
                this.checkeds = [];
            }
        },
        changeRun(code, yn) {
            var param = { workflowCode: code, runYn: yn };
            this.api.updateWorkflowRun(param).then((res) => {

                if(this.utils.preApiHandle(res)) {
                    console.log("profile edit res : ", res)
                }

                console.log("updateWorkflowRun res : ", res);
                if (res["code"] == 0) {
                    console.log(res.message);
                }

                this.getWorkflowList();

            });
        },
        // imagePaths(value) {
        // if (value != null && value != "") {
        //   return (
        //     "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
        //     value
        //   );
        // } else {
        //   return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
        // }
        //     return "/noimage.png";
        // },
        getWorkflowList() {
            var param = {
                userCode: this.userStore.userCode,
                groupCode: this.$store.state.workflowStore.groupCode,
                pageNum : this.pageNum,
                skipNum : this.skipNum
            };

            console.log(param);

            this.api.getWorkflowList(param).then((res) => {
                console.log("getWorkflowList res : ", res);

                if(this.utils.preApiHandle(res)) {
                    console.log("dev create page res : ", res)
                }


                if (res.code == 0) {
                    this.totalCount = res.totalCount;

                    var list = [];

                    if (res.workflows != undefined) {
                        for (var i = 0; i < res.workflows.length; i++) {

                            var schema = JSON.parse(res.workflows[i].workflowSchema);

                            var startImage = "";
                            var endImage = "";
                            if (schema.workflows[0].api.appImage != undefined && schema.workflows[0].api.appImage != null) {
                                startImage = schema.workflows[0].api.appImage;
                            }
                            if (schema.workflows[schema.workflows.length - 1].api.appImage != undefined && schema.workflows[schema.workflows.length - 1].api.appImage != null) {
                                endImage = schema.workflows[schema.workflows.length - 1].api.appImage;

                            }

                            console.log("ㅔㅕ노 : ", schema.workflows[schema.workflows.length - 1].api.appImage, schema.workflows.length);

                            var obj = {

                                workflowCode: res.workflows[i].workflowCode,
                                groupCode: res.workflows[i].groupCode,
                                workflowName: res.workflows[i].workflowName,
                                runYn: res.workflows[i].runYn,
                                deleteYn: res.workflows[i].deleteYn,
                                startImage: startImage,
                                endImage: endImage,
                                totalCount: schema.workflows.length,
                                templateYn: res.workflows[i].templateYn
                            };

                            list.push(obj);
                        }
                    }

                    this.getTasks();
                    this.workflowList = list;

                    this.$store.dispatch("saveWorkflows", list)

                }
            });
        },
        deleteWorkflow(code) {
            if (confirm("삭제 하시겠습니까?")) {

                var param = { workflowCodes: code };
                this.api.deleteWorkflow(param).then((res) => {

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile edit res : ", res)
                    }

                    console.log("deleteWorkflow res : ", res);
                    if (res["code"] == 0) {
                        alert("삭제 되었습니다.");
                    }

                    this.checkeds = [];
                    this.getWorkflowList();
                    this.getGroupList();

                });

            }
        },
        deleteWorkflowAll() {
            if (this.checkeds.length == 0) {
                alert("삭제할 workflow를 선택해 주세요");
                return;
            }
            if (confirm("삭제 하시겠습니까?")) {

                var param = { workflowCodes: this.checkeds.join() };
                this.api.deleteWorkflow(param).then((res) => {

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile edit res : ", res)
                    }

                    console.log("deleteWorkflow res : ", res);
                    if (res["code"] == 0) {
                        alert("삭제 되었습니다.");
                    }

                    this.checkeds = [];
                    this.getWorkflowList();
                    this.getGroupList();

                });

            }
        },
        goEditor(code) {
            this.$store.dispatch("saveWorkflowCode", code);

            var param = { workflowCode: code };
            this.api.getWorkflowDetail(param).then((res) => {

                if(this.utils.preApiHandle(res)) {
                    console.log("profile edit res : ", res)
                }

                console.log("getWorkflowDetail res : ", res);
                if (res["code"] == 0) {
                    this.$store.dispatch("saveWorkflow", res.workflow);
                    // this.totalApps();
                    this.$router.push({ path: "/workflows/editor/edit" });
                }
            });

        },
        getHistoryList() {
            this.$router.push({ name: "History" }).catch(() => {
            });
        },
        async goCreateworkflow() {

            if(this.flowTotal != -1 && (this.flowCount == this.flowTotal || this.flowCount > this.flowTotal)){
                alert("생성 가능한 최대 갯수에 도달하였습니다.")
            } else {
                var param = {};
                this.$store.dispatch("resetState", { params: param, tag: "workflow" }).then(() => {

                    this.buildWorkflows();
                    this.createWorkflow();
                    // this.totalApps();

                });
            }

        },
        async createWorkflow() {

            var param = {
                groupCode: this.workflowStore.groupCode,
                userCode: this.userStore.userCode,
                workflowName: this.workflowStore.workflowName,

                workflowCode: "",
                insertDt: "",
                workflows: JSON.stringify(this.workflowStore.workflowsS)
            };

            console.log(param)

            this.api.createWorkflow(param).then((res) => {

                if(this.utils.preApiHandle(res)) {
                    console.log("profile edit res : ", res)
                }

                console.log("createWorkflow res : ", res);
                if (res["code"] == 0) {
                    this.$store.dispatch("saveWorkflowCode", res.workflowCode);
                    this.$router.push({ path: "/workflows/editor/new" }).catch(() => {
                    });
                }
            });

        },
        buildWorkflows() {
            const workflows = [];
            const tObj = { type: "trigger", index: 0, testYn: 'N' };
            const aObj = { type: "action", index: 1, testYn: 'N'};

            tObj.authentication = JSON.parse(
                JSON.stringify(this.workflowStore.authenticationS)
            );
            tObj.api = JSON.parse(JSON.stringify(this.workflowStore.apiS));

            aObj.authentication = JSON.parse(
                JSON.stringify(this.workflowStore.authenticationS)
            );
            aObj.api = JSON.parse(JSON.stringify(this.workflowStore.apiS));

            workflows.push(tObj);
            workflows.push(aObj);

            this.$store.dispatch("buildWorkflows", workflows);

        },
        getGroupList() {
            var param = { userCode: this.userStore.userCode };
            this.api.getGroupList(param).then((res) => {

                // if(this.utils.preApiHandle(res)) {
                //   console.log("profile edit res : ", res)
                // }

                console.log("getGroupList res : ", res);
                if (res["code"] == 0) {
                    this.$store.dispatch("saveGroups", res.groups);
                }
            });
        },
        clickDropOutside() {
            if (this.workflowDropCode == "") {
                return;
            }

            this.workflowDropCode = "";
        },
        totalApps() {
            var param = { userCode: this.userStore.userCode, keyword: this.keyword };
            this.api.appSelect(param).then((res) => {
                console.log("appSelect res : ", res);

                // if(this.utils.preApiHandle(res)) {
                //   console.log("dev create page res : ", res)
                // }


                if (res["code"] == 0) {
                    this.$store.dispatch("saveApps", res.app);
                }
            });
        },
        getTasks(){
            this.api.getUserTask({
                companyCode : this.$store.state.userStore.userCode,
                dateOfSearch : null,
                siteCode : this.$store.state.userStore.siteCode
            })
                .then((res) => {

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile create res : ", res)
                    }

                    console.log(res)
                    if (res.code == 0) {
                        console.log(res);
                        // this.planName = res.task.planName
                        this.flowCount = res.task.flowCount
                        this.flowTotal = res.task.flowTotal
                        this.workCount = res.task.workCount
                        this.workTotal = res.task.workTotal
                        this.leadCount = res.task.leadCount
                        this.leadTotal = res.task.leadTotal
                        // this.planType = res.task.planName

                        if(res.status == "N"){
                            alert("플랜기간이 만기했습니다.");
                            this.$router.push({name:'ProfilePage'})
                        }


                    } else {

                        alert("오류가 발생했습니다.");
                        location.href="/";
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        goConnections(index) {

            // var workflowCode = this.workflowList[index].workflow





            // var param = { userCode: this.$store.state.userStore.userCode };
            // this.api.getConnectionList(param).then((res) => {
            //   console.log("getConnectionList res : ", res);
            //   if (res["code"] == 0) {
            //     this.$store.dispatch("saveConnections", res.connections);
            this.$router.push({ name: "ConnectionPage", params:{workflowCode : this.workflowList[index].workflowCode} });
            // }
            // });
        }
    },
    created() {
        console.log("user workflow workflow.created");
        var param = { userCode: this.$store.getters.getUserCode };
        this.api.getGroupList(param).then((res) => {
            console.log("getGroupList res : ", res);

            if(this.utils.preApiHandle(res)) {
                console.log("dev create page res : ", res)
            }

            if (res.code == 0) {

                for (var i = 0; i < res.groups.length; i++) {
                    if (res.groups[i].groupName == "홈") {

                        this.$store.state.workflowStore.groupCode = res.groups[i].groupCode;

                        this.getWorkflowList();
                    }
                }

            }
        });


    }
};
</script>
